<div class="plan-upgrade">
  <button
    *ngIf="canPay; else contactSales"
    type="button"
    class="btn btn-primary plan-upgrade__button"
    (click)="open()"
    [disabled]="isBusy">
    <i class="fas fa-credit-card" aria-hidden="true"></i>
    {{ 'payments.change_plan' | translate }}
  </button>

  <ng-template #contactSales>
    <button type="button" class="btn btn-outline-secondary plan-upgrade__button" disabled>
      <i class="fas fa-envelope" aria-hidden="true"></i>
      {{ 'payments.contact_sales' | translate }}
    </button>
    <span class="plan-upgrade__hint" *ngIf="wompiEnabled && eligibility.reasonKey">
      {{ eligibility.reasonKey | translate }}
    </span>
  </ng-template>

  <app-payment-status-card
    *ngIf="snapshot.phase !== 'idle'"
    [snapshot]="snapshot">
  </app-payment-status-card>

  <app-plan-upgrade-confirm-dialog
    *ngIf="showConfirm"
    [plan]="plan"
    [price]="price"
    [isBusy]="isBusy"
    (cancelled)="showConfirm = false"
    (confirmed)="confirm()">
  </app-plan-upgrade-confirm-dialog>
</div>
